
import CpuCharge from "../../../assets/duotone/CpuCharge.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CpuChargeIcon({ className, dataTestid = "CpuChargeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CpuCharge data-testid={dataTestid} className={classes} {...rest} />
  );
}
